<template>
  <BaseModal
    :modal-name="name"
    max-width="max-w-2xl"
    :close-button="false"
    :hide-overflow="false"
  >
    <p
      class="text-center text-xl font-medium leading-[42px] tracking-tight text-darkestGray"
    >
      {{ title }}
    </p>
    <p
      class="mt-5 text-center text-sm leading-6 tracking-tight text-darkestGray"
    >
      {{ $t('cart.action_or_remove_form_cart', { action: title }) }}
    </p>

    <div
      v-if="cartStore.shouldBeSelectedCity"
      class="mt-10 flex w-full justify-center"
    >
      <CartSelectCityList v-model="selectedCity" />
    </div>

    <div
      class="mt-5 flex grid-cols-2 flex-col-reverse gap-x-5 text-center sm:grid"
    >
      <BaseButton theme="link" @click="onClickClearItems">
        {{ $t('cart.remove_items') }}
      </BaseButton>

      <BaseButton
        v-if="cartStore.shouldBeSelectedPoint"
        theme="secondary"
        class="group relative flex w-full flex-col justify-center pr-12"
        @click="onClickChooseCollectionPoint"
      >
        {{ $t('action.choose_facility') }}
        <inline-svg
          :src="useAsset(`icons/base/alab_marker.svg`)"
          class="absolute right-[16px]"
        />
      </BaseButton>

      <BaseButton
        v-if="cartStore.shouldBeSelectedCity"
        theme="default"
        @click="onClickSelectCity"
      >
        {{ $t('cart.choose_city') }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import InlineSvg from 'vue-inline-svg'
import { useModalsStore } from '~/stores/modals'
import { useCartStore } from '~/stores/cart'

const name = 'selectCollectionPointOrCityModal'
const {
  public: { baseUrl },
} = useRuntimeConfig()

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const modalStore = useModalsStore()
const cartStore = useCartStore()

const selectedCity = ref(null)

const title = computed(() => {
  return cartStore.shouldBeSelectedPoint
    ? t('action.choose_facility_long')
    : t('cart.choose_city')
})

const onClickClearItems = () => {
  cartStore.clearItems()
  modalStore.close(name)
}

const onClickChooseCollectionPoint = () => {
  router.push({
    path: '/punkty-pobran',
    query: { returnTo: `${baseUrl}${route.fullPath}` },
  })
  modalStore.close(name)
}

const onClickSelectCity = async () => {
  if (selectedCity.value) {
    cartStore.setSelectedCity(selectedCity.value)
    await cartStore.updateServicesPrices()
    await cartStore.fetchNursingServices()
  }
  modalStore.close(name)
}
</script>
